<template>
  <div class="cntract-row" @click="detailContract">
    <div class="cntract-date">
      <div class="fnt-small">
        {{ dateUtils.formatYear(contract.transaction_date) }}
      </div>
      <div class="fnt-large">
        {{ dateUtils.formatMonthDay(contract.transaction_date) }}
      </div>
      <div class="fnt-small">
        {{ dateUtils.getDayEng(contract.transaction_date) }}
      </div>
    </div>
    <div class="cntract-data">
      <div class="use-date">
        <div class="use fnt-large">【メモ】{{ contract.use }}</div>
        <div class="date">
          ({{ dateUtils.formatDateYYYYMMDD(contract.created_at) }} 取込)
        </div>
      </div>
      <div class="img">
        <i class="icon-picture"></i>
      </div>
    </div>
  </div>
</template>
<script>
import DateUtils from '@/helpers/dateUtils';

export default {
    name: "CommonContractRow",
    props: {
        contract: {},
    },
    components: {},
    data () {
        return {
            dateUtils: DateUtils,
        };
    },
    methods: {
        detailContract (){
            this.$emit("detail");
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/views/components/common/ContractRow.vue